module.exports = __webpack_public_path__ + "cm.svg?08d975a376269d2b52d952975a29cb2f";